import AiqDialog from 'components/UI/Dialogs/AiqDialog';
import styles from './Help.module.css';
import Divider from '@mui/material/Divider';
import CircleQuestion from 'components/icons/Circlequestion';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import circleQuestion from 'assets/KeyboardHelp.svg';

const keyboardShortcuts = [
    {
        heading: 'transaction navigation',
        commands: [
            { shortcut: 'CTRL + Number', description: 'activate nth(Number) transaction tab' },
            { shortcut: 'CTRL + O', description: 'activate <i>Reopen</i> tab' },
            { shortcut: 'CTRL + Enter', description: 'submit opened transaction and populate fields with <b>/ (slash)</b> or suggested values' },
            { shortcut: 'Ctrl + Del', description: 'discard opened transaction' },
            { shortcut: 'F11', description: 'open video wall in fullscreen mode <span> [Browser default]</span>' },
            { shortcut: 'Shift + Mouse', description: 'scroll page horizontally <span> [Browser default]</span>' },
        ],
    },
    {
        heading: 'transaction navigation',
        commands: [
            { shortcut: 'CTRL + Q', description: 'select first enabled input' },
            { shortcut: 'CTRL + E', description: 'select first enabled and empty (has no value) input' },
            { shortcut: 'Tab', description: 'move focus to the next field (component) <span> [Browser default]</span>' },
            { shortcut: 'Shift + Tab', description: 'move focus to the previous field (component) <span> [Browser default]</span>' },
            { shortcut: 'Ctrl + /', description: 'auto-fill empty inputs with slashes' },
        ],
    },
    {
        heading: 'Audio & Microphone',
        commands: [
            { shortcut: 'CTRL + M', description: 'mute/unmute audio' },
            { shortcut: 'CTRL + D', description: 'mute/unmute microphone' },
        ],
    },
    {
        heading: 'Camera & Media Controls',
        commands: [
            { shortcut: 'Alt + Z', description: 'open last selected camera in fullscreen' },
            { shortcut: 'Alt + S', description: 'snapshot selected camera feed' },
            { shortcut: 'Alt + Shift + S', description: 'snapshot all camera feeds' },
            { shortcut: 'Alt + D', description: 'download selected media' },
            { shortcut: 'Alt + Shift + D', description: 'download all media' },
            { shortcut: 'Alt + R', description: 'reset zoom on selected media' },
            { shortcut: 'Alt + Shift + R', description: 'rotate selected media' },
            { shortcut: 'Alt + ←', description: 'select previous media' },
            { shortcut: 'Alt + →', description: 'select next media' },
        ],
    },
];

function Help() {
    const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);

    const toggleOpenHelpDialog = () => setIsHelpDialogOpen((state) => !state);
    const shortcuts = keyboardShortcuts.map(({ heading, commands }, index) => (
        <div className={styles.container} key={heading || index}>
            <p className={styles.headingInfo}>{heading}</p>
            {commands.map(({ shortcut, description }) => {
                const cleanText = DOMPurify.sanitize(description);
                return (
                    <div className={styles.shortcut} key={shortcut}>
                        <p>
                            <strong>{shortcut}</strong>
                            <span> - </span>
                            <span className={styles.specificText} dangerouslySetInnerHTML={{ __html: cleanText }}></span>
                        </p>
                    </div>
                );
            })}
        </div>
    ));

    return (
        <>
            <img onClick={toggleOpenHelpDialog} alt="Info Icon" className={styles['info-icon']} src={circleQuestion} />
            {isHelpDialogOpen && (
                <AiqDialog
                    sxContent={{ padding: '0' }}
                    sx={{ padding: 0 }}
                    open={isHelpDialogOpen}
                    onClose={toggleOpenHelpDialog}
                    title="Keyboard shortcuts"
                    icon={<CircleQuestion className={styles.iconHeading} />}
                >
                    <Divider sx={{ marginBottom: '0.5rem' }} />
                    {shortcuts}
                    <Divider sx={{ marginTop: '0.5rem' }} />
                </AiqDialog>
            )}
        </>
    );
}

export default Help;
